import script from "./nothing_found.vue?vue&type=script&setup=true&lang=js"
export * from "./nothing_found.vue?vue&type=script&setup=true&lang=js"

import "./nothing_found.vue?vue&type=style&index=0&id=a4b25768&scoped=true&lang=sass"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4b25768"]])

export default __exports__